<!--
 * @Author: Belief liang.huang@rockynet.onaliyun.com
 * @Date: 2025-11-04 16:55:53
 * @LastEditors: hl
 * @LastEditTime: 2026-03-26 15:00:00
 * @FilePath: /mall-wap-vue/src/views/mine/question/detail/components/AboutPlatform.vue
-->
<template>
  <div class="question">
    <template v-if="$appSource === 3">
      <div class="item item_title">Milky Cloud</div>
      <div class="item item_title">
        连接全球好品牌，与广大消费者共享美好生活
      </div>

      <div class="item item_title section_bg">品牌定位</div>
      <div class="item">
        Milky
        Cloud是一站式智慧零售平台，专注将澳新及全球优质品牌与广大消费者紧密相连。我们不仅是跨境购物平台，更是品质生活的桥梁。
      </div>

      <div class="item item_title section_bg">使命愿景</div>
      <div class="item">我们相信：</div>
      <div class="item item_title flex-center">
        <div class="blue_dot">·</div>
        <div>每一份优质营养都值得被传递</div>
      </div>
      <div class="item item_title flex-center">
        <div class="blue_dot">·</div>
        <div>每一次消费体验都应充满温度</div>
      </div>
      <div class="item">
        Milky
        Cloud致力于让更多消费者足不出户即可轻松触达全球精选产品，享受健康、便捷与美好的生活方式。
      </div>

      <div class="item item_title section_bg">平台价值</div>
      <div class="item item_title flex-center">
        <div class="blue_dot">·</div>
        <div class="item_title">
          全球精选：<span class="normal"
            >澳新起步，延展至全球，严选优质品牌。</span
          >
        </div>
      </div>
      <div class="item item_title flex-center">
        <div class="blue_dot">·</div>
        <div class="item_title">
          责任担当：<span class="normal"
            >不仅销售产品，更有使命推荐值得信赖的好品牌。</span
          >
        </div>
      </div>
      <div class="item item_title flex-center">
        <div class="blue_dot">·</div>
        <div class="item_title">
          安心体验：<span class="normal"
            >承诺“海外正品保障，海外直供”，让每一位用户放心购买。</span
          >
        </div>
      </div>
      <div class="item item_title flex-center">
        <div class="blue_dot">·</div>
        <div class="item_title">
          智慧零售：<span class="normal"
            >通过科技赋能，创造便捷、舒心、省心的跨境购物体验。</span
          >
        </div>
      </div>

      <div class="item item_title section_bg">品牌承诺</div>
      <div class="item">
        Milky Cloud承诺，所有商品均为
        <span class="item_title">海外正品直供</span
        >，我们为您甄选世界好物，只为让每一位用户拥有更优质的生活、更安心的体验。
      </div>
    </template>

    <template v-else>
      <div class="item item_title">妙客云 · MilkCloud</div>
      <div class="item item_title">连接全球好品牌，与中国家庭共享美好生活</div>

      <div class="item item_title section_bg">品牌定位</div>
      <div class="item">
        妙客云是一站式智慧零售平台，专注将澳新及全球优质品牌与中国家庭紧密相连。我们不仅是跨境购物平台，更是品质生活的桥梁。
      </div>

      <div class="item item_title section_bg">使命愿景</div>
      <div class="item">我们相信：</div>
      <div class="item item_title flex-center">
        <div class="blue_dot">·</div>
        <div>每一份优质营养都值得被传递</div>
      </div>
      <div class="item item_title flex-center">
        <div class="blue_dot">·</div>
        <div>每一次消费体验都应充满温度</div>
      </div>
      <div class="item">
        妙客云致力于让更多中国消费者足不出户即可轻松触达全球精选产品，享受健康、便捷与美好的生活方式。
      </div>

      <div class="item item_title section_bg">平台价值</div>
      <div class="item item_title flex-center">
        <div class="blue_dot">·</div>
        <div class="item_title">
          全球精选：<span class="normal"
            >澳新起步，延展至全球，严选优质品牌。</span
          >
        </div>
      </div>
      <div class="item item_title flex-center">
        <div class="blue_dot">·</div>
        <div class="item_title">
          责任担当：<span class="normal"
            >不仅销售产品，更有使命推荐值得信赖的好品牌。</span
          >
        </div>
      </div>
      <div class="item item_title flex-center">
        <div class="blue_dot">·</div>
        <div class="item_title">
          安心体验：<span class="normal"
            >承诺“海外正品保障，海外直供”，让每一位用户放心购买。</span
          >
        </div>
      </div>
      <div class="item item_title flex-center">
        <div class="blue_dot">·</div>
        <div class="item_title">
          智慧零售：<span class="normal"
            >通过科技赋能，创造便捷、舒心、省心的跨境购物体验。</span
          >
        </div>
      </div>

      <div class="item item_title section_bg">品牌承诺</div>
      <div class="item">
        妙客云承诺，所有商品均为
        <span class="item_title">海外正品直供</span
        >，我们为您甄选世界好物，只为让每一位用户拥有更优质的生活、更安心的体验。
      </div>
    </template>
  </div>
</template>

<script>
export default {
  methods: {
    backClick() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.question {
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 22px;
  padding: 15px;
  border-top: 1px solid #eee;
}
.item {
  margin-top: 10px;
}
.item_index {
  span-indent: 25px;
}
.item_title {
  font-size: 14px;
  font-weight: 500;
  color: rgba(34, 34, 34, 1);
}
.item_top {
  margin-top: 30px;
}
.go {
  color: #2976e8;
}

.section_bg {
  width: 100%;
  background-color: #fff6eb;
}

.blue_dot {
  font-size: 30px;
  color: #2976e8;
  margin-right: 9px;
}

.flex-center {
  display: flex;
  justify-content: start;
  align-items: start;
}

.normal {
  font-weight: 400;
}
</style>
